/** The global navigation remains pinned at the top on every viewport. */
class StellaHeader extends HTMLElement {}

customElements.define('stella-header', StellaHeader);
